var React = require('react');

function FinishFlag (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M6 28V5h20v14H6","style":{"fill":"none","stroke":"#000","strokeWidth":"2","strokeMiterlimit":"10"},"key":0}),React.createElement("path",{"d":"M22 5h4v4h-4zM19 15h3v4h-3zM19 9h3v3h-3zM13 15h3v4h-3zM13 9h3v3h-3zM6 15h4v4H6zM6 9h4v3H6zM22 12h4v3h-4zM16 12h3v3h-3zM10 12h3v3h-3zM16 5h3v4h-3zM10 5h3v4h-3z","key":1})]);
}

FinishFlag.defaultProps = {"xmlSpace":"preserve","width":"64","height":"64","viewBox":"0 0 32 32"};

module.exports = FinishFlag;

FinishFlag.default = FinishFlag;
